import { TestAccountMapEntry } from "./testAccountHealth.types"

const RP_PROJECT = "fe-nova"

const test = (spec: string, rpNameFilter: string) => ({
  spec,
  rpProject: RP_PROJECT,
  rpNameFilter,
})

// Junifer's find_test_accounts.latest_status is the per-meterpoint
// supplyStatus - a switching/registration vocabulary, NOT an account
// lifecycle status. 'Active' is not a value it can ever hold. This is the
// "accounts on supply" (healthy) set from
// be-ac-junifer/service/src/main/resources/db/sql/get_resolved_loss_accounts.sql;
// LossInitiated/LossNotified/LossConfirmed are deliberately excluded - an
// in-progress or completed loss on a test account is genuine drift.
// See docs/superpowers/specs/2026-07-24-test-account-health-drift-triage-design.md.
const ACCOUNTS_ON_SUPPLY_STATUSES = [
  "RegistrationAccepted",
  "Registered",
  "RegistrationConfirmed",
  "RegistrationCompleted",
  "RegistrationRequested",
  "LossObjectionRaised",
  "LossObjected",
  "LossObjectionUpheld",
]

export const TEST_ACCOUNT_MAP: TestAccountMapEntry[] = [
  {
    accountNumber: "00862649",
    role: "Happy path (default customer-section account)",
    expected: {
      accountStatus: ACCOUNTS_ON_SUPPLY_STATUSES,
      hasActiveAgreement: true,
    },
    tests: [
      test("engage_complaints", "Complaints"),
      test("engage_psrModal", "PSR"),
      test("engage_timeline", "Timeline"),
      test("join_movein", "Move in"),
      test("measure_financials", "Financials"),
      test("measure_meterpoints", "Meterpoints"),
      test("measure_smartDevices", "Smart devices"),
      test("thrive_agreements", "Agreements"),
      test("thrive_moveout", "Move out"),
      test("thrive_renewals", "Renewals"),
    ],
  },
  {
    accountNumber: "00130270",
    role: "Overview review (needs no active Junifer review period - not machine-checked)",
    expected: {
      accountStatus: ACCOUNTS_ON_SUPPLY_STATUSES,
      hasActiveAgreement: true,
    },
    tests: [test("engage_overview", "Overview")],
  },
  {
    accountNumber: "01580619",
    role: "Traditional meters, no available SMBP slots",
    expected: { meterKind: "TRADITIONAL" },
    tests: [test("measure_smartDevices", "Smart devices")],
  },
  {
    accountNumber: "01580621",
    role: "S1 smart meter (booking CTA hidden)",
    expected: { meterKind: "SMETS1" },
    tests: [test("measure_smartDevices", "Smart devices")],
  },
  {
    accountNumber: "00125374",
    role: "S2 smart meter (booking CTA hidden)",
    expected: { meterKind: "SMETS2" },
    tests: [test("measure_smartDevices", "Smart devices")],
  },
]
